// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__d_n9f","footer":"ModalCreateQualiphyProcedure_footer__376i4","additionData":"ModalCreateQualiphyProcedure_additionData__3AQ-N"};